import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "menu", "button" ]

  connect() {
    this.closeAllMenus()
  }

  openMenu(event) {
    const target = event.target.closest("tr").querySelector(`[data-table-actions-target="menu"]`)
    const opened = !target.classList.contains("hidden")

    this.closeAllMenus()

    if (!opened) {
      target.classList.remove("hidden")
    }
  }

  closeAllMenus(event) {
    console.log("closeAllMenus")
    if (event && (this.buttonTargets.some((el) => el.contains(event.target)))) {
      return;
    }

    this.menuTargets.forEach((element) => {
      element.classList.add("hidden")
    })
  }
}
